import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import employeesService from '../services/employeesService';
import EmployeeForm from '../components/EmployeeForm';
import { useNotification } from '../context/NotificationContext';
import '../styles/general.css';

const EmployeeFormPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { notify } = useNotification();
  const isEditMode = !!id;

  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(isEditMode);

  useEffect(() => {
    if (!isEditMode) return;

    const fetchEmployee = async () => {
      try {
        const res = await employeesService.getEmployeeById(id);
        setEmployee(res.data);
      } catch (err) {
        console.error('Error loading employee:', err);
        notify.error(t('common.failedToLoad'));
      } finally {
        setLoading(false);
      }
    };
    fetchEmployee();
  }, [id, isEditMode, t, notify]);

  if (loading) {
    return <div className="loading">{t('common.loading')}</div>;
  }

  // The backend rejects writes to an inactive employee, so the edit form would
  // be a dead end. Send the user to the read-only view instead of letting them
  // fill it in and hit a 400 on save.
  if (isEditMode && employee && !employee.is_active) {
    return <Navigate to={`/employees/${employee.id}`} replace />;
  }

  return (
    <div className="page-container-wide">
      <div className="page-header">
        <h1>{isEditMode ? t('employees.editTitle') : t('employees.createTitle')}</h1>
        {isEditMode && employee?.full_name && (
          <div className="order-number-badge">
            <span className="order-number-label">{t('table.fullName')}</span>
            <span className="order-number-value">{employee.full_name}</span>
          </div>
        )}
      </div>

      <EmployeeForm
        initialData={employee}
        onSuccess={() => navigate('/employees')}
        onCancel={() => navigate('/employees')}
      />
    </div>
  );
};

export default EmployeeFormPage;
